import { Drawer } from '@mui/material';

type InvoiceActivityDrawerProps = {
  children: React.ReactNode;
  isDialogOpen: boolean;
  handleClose: () => void;
};

export const InvoiceActivityDrawer: React.FC<InvoiceActivityDrawerProps> = ({
  isDialogOpen,
  handleClose,
  children,
}) => {
  return (
    <Drawer
      anchor="right"
      open={isDialogOpen}
      onClose={handleClose}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'transparent',
          },
        },

        paper: {
          sx: {
            position: 'fixed',
            height: 'calc(100vh - 16px)',
            width: 384,
            top: '8px',
            right: '8px',
            borderRadius: 2,
            border: '1px solid rgba(13, 27, 39, 0.1)',
            background: '#FFF',
            boxShadow: '0px 1px 10px rgba(13, 27, 39, 0.03), 0px 1px 5px rgba(13, 27, 39, 0.03)',
            overflow: 'hidden',
          },
        }
      }}>
      {children}
    </Drawer>
  );
};
